<script lang="ts">
  import type { InstructorModel } from '@24hbs/utils';
  import { handleUrlClientSide } from '$lib/utils/assets-utils';
  import classnames from 'classnames';

  export let instructor: InstructorModel;
</script>

<div class={classnames('instructor-header', $$props.class)}>
  <div class="instructor-header-image">
    <img
      width="200"
      height="200"
      src={handleUrlClientSide(instructor.imageUrl)}
      alt="{instructor.name} {instructor.surname}"
    />
  </div>
  <div class="instructor-header-detail">
    <h1 class="instructor-header-name">
      {instructor.name}
      {instructor.surname}
    </h1>
    <p class="instructor-header-competence subtitle">{instructor.jobTitle}</p>
    <strong class="instructor-header-description">{instructor.company}</strong>
    <div>
      {#if instructor.typology}
          <div class="credits">{instructor.typology}</div>
      {/if}
      {#if instructor.categories && instructor.categories.length > 0}
        {#each instructor.categories as category}
          <div class="credits">{category}</div>  
        {/each}
      {/if}
    </div>
  </div>

  <div class="instructor-header-content">
    <slot />
  </div>

  {#if $$slots['footer']}
    <div class="instructor-header-footer">
      <slot name="footer" />
    </div>
  {/if}
</div>

<style type="text/scss" lang="scss" scoped>
  .instructor-header {
    @apply flex;
    @apply flex-col md:flex-row md:flex-wrap;
    @apply items-center md:items-start;
  }

  .instructor-header-image {
    @apply max-w-xxs;
  }

  .instructor-header-detail {
    @apply flex flex-col;
    @apply items-center md:items-start;
    @apply md:flex-1;
    @apply md:pl-6;
  }

  .instructor-header-name {
    @apply text-lg md:text-3xl;
    @apply text-center;
    @apply mt-6 md:mt-0;
  }

  .instructor-header-competence {
    @apply text-center md:text-left;
    @apply md:mt-1.5;
  }

  .instructor-header-description {
    @apply w-full max-w-md;
    @apply mt-3 md:mt-4;
    @apply text-center md:text-left;
  }

  .instructor-header-content {
    @apply mt-8;
  }

  .instructor-header-footer {
    @apply mt-8 md:mt-14;
    @apply mx-auto md:mx-0;
  }
  .credits {
    @apply px-3 h-6 inline-flex items-center mt-1;
    @apply bg-black rounded-md;
    @apply text-white;
  }
</style>  